import React from 'react';
import { connect } from 'react-redux';

import TransferSuccess from './TransferSuccess';
import TransferFailure from './TransferFailure';
import RxError from '../RxError';
import StatusBanner from '../../common/StatusBanner';
import { formatPhoneNumber } from "../../../helpers/formatting";

import * as d from '../../../reducers/domainReducer';
import { logUI } from '../../../api/andyliticsApi';
import * as Tools from '../../../helpers/Tools';

class TransferConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const transferTypeLabel = this.props.isExternal ? "NonBSW" : "BSW";
        logUI("MBHWeb.UI.Rx." + transferTypeLabel + "TransferConfirmation.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    //tryAgainOnError() {
    //    if (this.props.tryAgain)
    //        this.props.tryAgain();
    //}

    getDrugInfo = (RxNumber) => {
        const { rxList } = this.props;
        var filtered = rxList && rxList.find(x => x.RxNumber === RxNumber);
        var drugName = filtered ? filtered.DrugName || filtered.RxDrugName : '';
        const ndcImageURL = filtered ? filtered.NDCImageURL : "";
        return { drugName, ndcImageURL };
    }

    newRequest = (e, reload) => {
        e.preventDefault();
        const transferTypeLabel = this.props.isExternal ? "External." : "";
        logUI("MBHWeb.Rx.Transfer." + transferTypeLabel + "TryAgainOrNewRequest", new Date(), Tools.getURLPath());
        if (this.props.onNewRequest) {
            this.props.onNewRequest(reload);
        }
    }

    render() {
        const { proxyUser, transfer, sourcePharmacy, destinationPharmacy, pharmacyDetails, hasPharmacyLogin, addressUrl } = this.props;
        var userName = proxyUser && proxyUser.firstName ? proxyUser.firstName : 'Your';
        const phoneNumber = formatPhoneNumber(destinationPharmacy.PhoneNumber);
        const serviceError = transfer && transfer.error !== null ? transfer.error : null;
        const result = transfer && transfer.result ? transfer.result : null;
        const successfullRxs = result ? result.SuccessRx : null;
        const notAllowedRxs = result ? result.NotAllowedRx : null;
        let failedRxs = result ? result.FailureRx : null;
        let partialSuccess = (successfullRxs && (notAllowedRxs || failedRxs));

        if (!successfullRxs && !notAllowedRxs && !failedRxs) {
            failedRxs = {
                Message: 'This request did not go through.',
                Prescriptions: transfer.prescriptions
            };
        }

        const message = successfullRxs
            ? 'Thanks, you’re' + (failedRxs ? '' : ' all') + ' set!' + (failedRxs ? ' Please review one error below.' : '')
            : 'We were unable to submit your request.';

        return (
            <div className="pharmacy-confirmation-container" style={this.props.style}>
                {!serviceError
                    ? <React.Fragment>
                        <StatusBanner bannerAlignment="left" bannerMsg={message} failedStatus={!successfullRxs} />
                        <div className={"row confirmation-summary-container" + (partialSuccess ? " partial-success" : "")}>
                            <div className="col-12 maxWidth-content">
                                <div className="row">
                                    <div className="col-12">
                                        <h2 className="h5 prescriptions-heading">Prescriptions:</h2>
                                    </div>
                                    <TransferFailure failedRxs={failedRxs} notAllowedRxs={notAllowedRxs} sourcePharmacy={sourcePharmacy} getDrugInfo={this.getDrugInfo} resetStep={this.newRequest} />
                                    <TransferSuccess successfullRxs={successfullRxs} sourcePharmacy={sourcePharmacy} destinationPharmacy={destinationPharmacy} getDrugInfo={this.getDrugInfo} addressUrl={addressUrl} proxyUser={proxyUser} />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                    : <React.Fragment>
                        {serviceError.status === 400 ?
                            <StatusBanner bannerAlignment="left" bannerMsg="We were unable to submit your request." subBannerMsg="A transfer is in progress for this person's account." failedStatus/>
                            : <StatusBanner bannerAlignment="left" bannerMsg="We were unable to submit your request." failedStatus >
                                <h2>
                                    This request did not go through. Please call your pharmacy {phoneNumber && <span>{" "}<a href={"tel:" + phoneNumber} className="phone-link">{phoneNumber}</a></span>} or <a href="#" onClick={(e) => this.newRequest(e, false)}>try again</a>.
                                </h2>
                            </StatusBanner>
                                //<RxError resetStep={this.newRequest} userName={userName} name={"transfer"} apiMessage="A transfer is in progress for this person's account." messageIcon="icon-transfer" sectionErrorClass="status-transfer-not-allowed" hasPharmacyLogin={hasPharmacyLogin || (proxyUser ? true : false)} />
                                //: <RxError resetStep={this.newRequest} userName={userName} name={"transfer"} hasPharmacyLogin={hasPharmacyLogin || (proxyUser ? true : false)} />
                        }
                    </React.Fragment>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        proxyUser: d.hydratePharmacyUser(state.domain.cpu)
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(TransferConfirmation);